/********************
 * Elements
 ********************/

const serverUrl = "https://morrow-soft-goods-prod.herokuapp.com";

const qs = (selector, scope = document) => {
  return scope.querySelector(selector);
};

const qsa = (selector, scope = document) => {
  return scope.querySelectorAll(selector);
};

const on = (el, event, handler, options) => {
  if (!el) return false;
  el.addEventListener(event, handler, options);
  return true;
};

const off = (el, event, handler, options) => {
  if (!el) return false;
  el.removeEventListener(event, handler, options);
  return true;
};

const getElements = () => {
  return {
    doc: document.documentElement,
    actions: qsa(`[data-action]`),
    sliders: qsa(`.splide`),
    expandingMenus: qsa(`[data-action="toggleExpandingMenu"]`),
    tooltips: qsa(`[data-action="toggleTooltip"]`),
    preloadTriggers: qsa(`[data-hover="preload-trigger"]`),
    cart: qs(".cart"),
    searchBar: qs(".search-bar"),
    body: qs("body"),
    forms: qsa(".form"),
  };
};

let elements = getElements();

/********************
 * Values
 ********************/

class Values {
  constructor() {
    this.init();
  }

  init() {
    this.variantTree = this.createVariantTree();
    this.bundleColorOptions =
      typeof bundleColorOptions === "undefined" ? false : bundleColorOptions;
    this.keys = {
      preorder: "Preorder",
      available: "In Stock",
      oos: "Out of Stock",
    };
    this.preloads = {};
  }

  createVariantTree() {
    const variants = [];
    const variantTree = qsa("#variantTree option");

    for (let i = 0; i < variantTree.length; i++) {
      const variant = variantTree[i];
      variants.push({
        id: "id" in variant.dataset ? variant.dataset.id : false,
        option1: "option1" in variant.dataset ? variant.dataset.option1 : false,
        option2: "option2" in variant.dataset ? variant.dataset.option2 : false,
        option3: "option3" in variant.dataset ? variant.dataset.option3 : false,
        price: "price" in variant.dataset ? variant.dataset.price : false,
        inventory:
          "inventory" in variant.dataset ? variant.dataset.inventory : false,
      });
    }

    return variants;
  }
}

const values = new Values();

/********************
 * Functions
 ********************/

class Functions {
  constructor() {
    this.init();
  }

  init() {}

  resetListeners() {
    elements = getElements();
    values.variantTree = values.createVariantTree();
    elements.actions = qsa(`[data-action]`);
    actions = registerActionEvents(actions);
    sliders = new Sliders();
  }

  closePdpDropdown(open) {
    if (!open) return;
    open.classList.remove("open");
  }

  getSelectedDropdown(option) {
    if (!option) return null;
    return qs(`.select-dropdown__dropdown__values[data-option="${option}"]`);
  }

  getOpenDropdown() {
    return qs(`.select-dropdown__dropdown__values.open`);
  }

  hoverOff() {
    const open = this.getOpenDropdown();
    if (open) {
      this.closePdpDropdown(open);
    }
  }

  getSelectedVariant(variantTree = false) {
    if (!variantTree) {
      variantTree = values.variantTree;
    }

    const selectedOptionTree = qsa('[data-action="togglePdpDropdown"]');
    const selectedOptions = {};

    for (let i = 0; i < selectedOptionTree.length; i++) {
      selectedOptions[
        `option${selectedOptionTree[i].getAttribute("data-order")}`
      ] = selectedOptionTree[i].getAttribute("data-value");
    }

    for (let i = 0; i < variantTree.length; i++) {
      const variant = variantTree[i];

      if (variant.option1 && variant.option1 !== selectedOptions.option1) {
        continue;
      }
      if (variant.option2 && variant.option2 !== selectedOptions.option2) {
        continue;
      }
      if (variant.option3 && variant.option3 !== selectedOptions.option3) {
        continue;
      }

      return {
        variantId: parseInt(variant.id, 10),
        price: parseFloat(variant.price / 100).toFixed(2),
        inventory: variant.inventory,
      };
    }

    return false;
  }

  getSelectedBundleColorVariant() {
    const selectedOptions = [];
    const domOptions = Array.from(qsa('[data-bundle="color-options"]'));

    for (let i = 0; i < domOptions.length; i++) {
      const domOption = domOptions[i];

      try {
        const colorEl = domOption.querySelector(`[data-optionhandle="Color"]`);
        const sizeEl = domOption.querySelector(`[data-optionhandle="Size"]`);

        if (!colorEl || !sizeEl) continue;

        selectedOptions.push({
          baseId: colorEl.getAttribute("data-baseid"),
          option1: colorEl.getAttribute("data-value"),
          option2: sizeEl.getAttribute("data-value"),
        });
      } catch (e) {
        continue;
      }
    }

    let price = 0;
    let variants = "";
    let colors = "";
    let sizes = "";
    let discountCode = "";
    let discountValue = 0;
    let globalOos = false;

    selectedOptions.map((option) => {
      option.found = false;
      return option;
    });

    if (values.bundleColorOptions) {
      for (let i in values.bundleColorOptions) {
        const option = values.bundleColorOptions[i][1];

        for (let x in selectedOptions) {
          const selectedOption = selectedOptions[x];

          if (option.baseId === selectedOption.baseId) {
            const oos = qs(
              `.select-dropdown__oos[data-baseid="${selectedOption.baseId}"]`
            );

            if (
              option.option1 === selectedOption.option1 &&
              option.option2 === selectedOption.option2
            ) {
              selectedOptions[x].found = true;
              variants = variants + option.variantId.toString() + ",";
              colors = colors + option.option1 + ", ";
              sizes =
                sizes +
                option.option2
                  .replace("Full / Queen", "F / Q")
                  .replace("King / Cal King", "K / CK")
                  .replace("Twin", "T")
                  .replace("Queen", "Q")
                  .replace("King", "K")
                  .replace("Cal King", "CK") +
                ", ";
              price = price + option.price;

              if (oos) {
                if (option.available) {
                  oos.classList.add("hide");
                } else {
                  oos.classList.remove("hide");
                  globalOos = true;
                }
              }

              if (
                parseInt(x, 10) === 0 &&
                typeof bundleColorDiscounts !== "undefined"
              ) {
                for (let y in bundleColorDiscounts) {
                  const discount = bundleColorDiscounts[y];

                  if (
                    option.option2.includes("Twin") &&
                    discount.size.includes("twin")
                  ) {
                    discountCode = discount.code;
                    discountValue = discount.value;
                  } else if (
                    option.option2.includes("Full") &&
                    discount.size.includes("full")
                  ) {
                    discountCode = discount.code;
                    discountValue = discount.value;
                  } else if (
                    option.option2.includes("Queen") &&
                    discount.size.includes("queen")
                  ) {
                    discountCode = discount.code;
                    discountValue = discount.value;
                  } else if (
                    option.option2.includes("King") &&
                    discount.size.includes("king")
                  ) {
                    discountCode = discount.code;
                    discountValue = discount.value;
                  }
                }
              }
            } else if (
              option.option1 === selectedOption.option1 &&
              option.option2 === selectedOption.option2 &&
              option.available === false
            ) {
              if (oos) oos.classList.remove("hide");
              globalOos = true;
              selectedOptions[x].found = true;
            }
          }
        }
      }
    }

    for (let i in selectedOptions) {
      const selectedOption = selectedOptions[i];
      if (!selectedOption.found) {
        const oos = qs(
          `.select-dropdown__oos[data-baseid="${selectedOption.baseId}"]`
        );
        if (oos) {
          oos.classList.remove("hide");
        }
      }
    }

    const globalOosEl = qs(
      `.product__cta__response--bundle-color-options [data-content="response"]`
    );
    const atcBundleBtn = qs('[data-action="atcBundle"][data-allow]');

    if (globalOosEl) {
      if (globalOos) {
        globalOosEl.classList.add("reveal");
        if (atcBundleBtn) atcBundleBtn.setAttribute("data-allow", "false");
      } else {
        globalOosEl.classList.remove("reveal");
        if (atcBundleBtn) atcBundleBtn.setAttribute("data-allow", "true");
      }
    }

    let addon = false;
    const addonSelector = qs(
      '[data-addon="true"] [data-action="togglePdpDropdown"]'
    );

    if (addonSelector && values.bundleColorOptions) {
      for (let i in values.bundleColorOptions) {
        const options = values.bundleColorOptions[i][1];
        const addonSize = addonSelector
          .getAttribute("data-value")
          .replaceAll(" ", "");
        const addonBaseId = parseInt(
          addonSelector.getAttribute("data-baseid"),
          10
        );

        if (
          addonSize === options.option2.replaceAll(" ", "") &&
          addonBaseId === options.baseId
        ) {
          addon = options.variantId;
          price = price + options.price;
          break;
        }
      }
    }

    variants = variants ? variants.slice(0, -1) : "";
    sizes = sizes ? sizes.slice(0, -2) : "";
    colors = colors ? colors.slice(0, -2) : "";
    price = price / 100;

    return {
      price,
      availability: true,
      variants,
      sizes,
      colors,
      discountCode,
      discountValue,
      addon,
    };
  }

  async loadNewPdp(handle) {
    const url = `/products/${handle}`;
    const html = await fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        return parser.parseFromString(html, "text/html");
      })
      .catch(function (err) {
        console.warn("Something went wrong.", err);
        return false;
      });

    if (html) {
      const newProductContent = html.getElementById("MainContent");
      const container = document.getElementById("MainContent");

      if (!newProductContent || !container) {
        return false;
      }

      if (values.preloads[handle]) {
        newProductContent.innerHTML = newProductContent.innerHTML.replace(
          values.preloads[handle].src300,
          values.preloads[handle].src
        );
      }

      container.innerHTML = newProductContent.innerHTML;
      this.resetListeners();

      window.history.replaceState({}, "", `${window.location.origin}${url}`);
      return true;
    } else {
      console.log("check functions.js - error");
      return false;
    }
  }

  openSearchBar() {
    if (elements.searchBar) {
      elements.searchBar.classList.add("active", "activated");
    }
    if (elements.body) {
      elements.body.classList.add("no-scroll", "menu-open");
    }
    const overlay = qs(".search-bar__overlay");
    if (overlay) {
      overlay.classList.add("active");
    }
  }

  closeSearchBar() {
    if (elements.searchBar) {
      elements.searchBar.classList.remove("active");
    }
    if (elements.body) {
      elements.body.classList.remove("no-scroll", "menu-open");
    }
    const overlay = qs(".search-bar__overlay");
    if (overlay) {
      overlay.classList.remove("active");
    }
  }

  async subscribeKlaviyo(form) {
    const config = addToKlaviyoListConfig(form);

    const response = await fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=Je92s3",
      config
    )
      .then(() => {
        return {
          status: "success",
        };
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
        return {
          status: "errorOnSubscribe",
        };
      });

    return await response;
  }

  async subscribeKlaviyoOos(form) {
    const config = addToWaitlistConfig(form);

    return await fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=Je92s3",
      config
    )
      .then(() => {
        return {
          status: "success",
        };
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
        return {
          status: "errorOnSubscribe",
        };
      });
  }
}

const functions = new Functions();
window.functions = functions;

/********************
 * Actions
 ********************/

class Actions {
  constructor() {
    this.init();
  }

  init() {
    this.listeners = [];
  }

  async createDiscount(item) {
    function hashCode(str) {
      return str
        .split("")
        .reduce(
          (prevHash, currVal) =>
            ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
          0
        );
    }

    const discountValue = parseFloat(
      parseInt(item.getAttribute("data-discount"), 10) / 100
    ).toFixed(2);

    const timestamp = new Date();
    let hash = hashCode(timestamp.toString()).toString();
    const discountHandle = "BUNDLE_" + hash.replace("-", "");
    const form = JSON.stringify({
      currentDiscounts: [
        {
          code: discountHandle,
          amount: discountValue,
          minimum: 100.0,
        },
      ],
    });

    const response = await fetch(`${serverUrl}/api/createBundleDiscounts`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: form,
    })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
        return false;
      });

    if (response) {
      window.location.href = `/checkout?discount=${discountHandle}`;
    }
  }

  async atc(item) {
    const variantId = item.getAttribute("data-variantId");

    if (variantId === "0") {
      const productId = item.getAttribute("data-productId");
      const error = qs(
        `[data-content="atcError"][data-productId="${productId}"]`
      );
      if (error) {
        error.classList.add("active");
      }
      return;
    }

    if (item.getAttribute("data-preorder") === "true") {
      await cart.addToCart(
        variantId,
        item.getAttribute("data-quantity"),
        true,
        item.getAttribute("data-preorder-date")
      );
      await cart.updateCart();
    } else {
      await cart.addToCart(variantId, item.getAttribute("data-quantity"));
      await cart.updateCart();
    }
  }

  async atcBundle(item) {
    const allow = item.getAttribute("data-allow");
    if (allow === "false") {
      return;
    }

    const allSelected = Array.from(qsa("[data-selected-ids]"));
    const filteredSelected = allSelected.filter(
      (item) => item.getAttribute("data-selected-ids") !== ""
    );

    let variantString = "";

    for (let i = 0; i < filteredSelected.length; i++) {
      variantString += filteredSelected[i].getAttribute("data-selected-ids");
      if (i < filteredSelected.length - 1) {
        variantString += ",";
      }
    }

    if (variantString === "") {
      console.log("error, no variants available");
      return;
    }

    const quantity = item.getAttribute("data-quantity");
    const priceEl = qs('[data-content="price"]');

    const items = variantString.split(",").map((id) => {
      return {
        id: parseInt(id, 10),
        quantity: parseInt(quantity, 10),
        properties: {
          _bundle_id: `${item.getAttribute("data-bundle-id")}`,
          _bundle_title: `${item.getAttribute("data-bundle-title")}`,
          _bundle_colors: `${item.getAttribute("data-bundle-colors")}`,
          _bundle_sizes: `${item.getAttribute("data-bundle-sizes")}`,
          _bundle_handle: `${item.getAttribute("data-bundle-handle")}`,
          _bundle_type: `${item.getAttribute("data-bundle-type")}`,
          _bundle_price: priceEl ? priceEl.innerHTML : "",
        },
      };
    });

    let discount = false;
    const code = item.getAttribute("data-discount-code");
    const value = item.getAttribute("data-discount-value");

    if (code && value) {
      discount = {
        code,
        value: parseInt(value, 10),
      };
    }

    if (items.length < 2) {
      discount = false;
    }

    const addon = item.getAttribute("data-addon-id");
    if (addon && addon !== "false") {
      const addonItem = {
        id: parseInt(addon, 10),
        quantity: parseInt(quantity, 10),
        properties: {
          _bundle_id: `${item.getAttribute("data-bundle-id")}`,
          _bundle_addon: true,
          _bundle_handle: `${item.getAttribute("data-bundle-handle")}`,
          _bundle_type: `${item.getAttribute("data-bundle-type")}`,
          _bundle_price: priceEl ? priceEl.innerHTML : "",
          _bundle_colors: `${item.getAttribute("data-bundle-colors")}`,
          _bundle_sizes: `${item.getAttribute("data-bundle-sizes")}`,
        },
      };
      items.push(addonItem);
    }

    await cart.addBundleToCart(items, discount);
    await cart.updateCart();
  }

  selectBundle(item) {
    const option = item.getAttribute("data-option");
    const ids = item.getAttribute("data-ids");
    const title = item.getAttribute("data-title");
    const oosData = item.getAttribute("data-oos") || "";
    const oos = oosData.slice(0, -1).split(",");
    const oosElem = qs(`.select-dropdown__oos[data-option="${option}"]`);

    if (oosElem) {
      if (oos.length && oos[0] !== "" && oos[0] !== " -  / ") {
        let html = `<div class="select-dropdown__oos__title">Out of stock:</div>`;
        for (let x in oos) {
          html += `<div class="select-dropdown__oos__item">${oos[x]}</div>`;
        }
        oosElem.innerHTML = html;
      } else {
        oosElem.innerHTML = "";
      }
    }

    let price = item.getAttribute("data-price");
    const optionToggle = qs(`[data-option="${option}"][data-selected-ids]`);

    if (optionToggle) {
      optionToggle.setAttribute("data-selected-ids", ids);
      optionToggle.setAttribute("data-selected-price", price);
    }

    price = 0;

    const selected = qs(
      `.select-dropdown__dropdown__option.active[data-option="${option}"]`
    );
    if (selected) {
      selected.classList.remove("active");
    }

    item.classList.add("active");

    const open = functions.getOpenDropdown();
    functions.closePdpDropdown(open);

    const toggleLabel = qs(
      `[data-action="togglePdpDropdown"][data-option="${option}"] span`
    );
    if (toggleLabel) {
      toggleLabel.innerHTML = title;
    }

    const allSelected = qsa("[data-selected-ids]");
    for (let i = 0; i < allSelected.length; i++) {
      const item = allSelected[i];
      price = price + parseInt(item.getAttribute("data-selected-price"), 10);
    }

    const priceEl = qs('[data-content="price"]');
    const paymentsEl = qs('[data-content="payments"]');

    if (priceEl) priceEl.innerHTML = (price / 100).toFixed(2);
    if (paymentsEl) paymentsEl.innerHTML = (price / 400).toFixed(2);
  }

  selectSwatch(item) {
    const handle = item.getAttribute("data-handle");
    if (handle) {
      functions.loadNewPdp(handle);
    }
  }

  togglePdpDropdown(item) {
    const status = item.getAttribute("data-status");
    item.setAttribute("data-status", status === "open" ? "closed" : "open");

    const option = item.getAttribute("data-option");
    const close = functions.getOpenDropdown();

    if (close) {
      close.classList.remove("open");
    }

    const open = functions.getSelectedDropdown(option);
    if (!open) return;

    if (!close || close !== open) {
      open.classList.add("open");
    }

    on(open, "mouseleave", () => {
      functions.closePdpDropdown(open);
      item.setAttribute("data-status", "closed");
    });
  }

  mrwSelectPdpOption(item) {
    if (!item.matches('[data-mrw="selectPdpOption"]')) return false;

    const group = item.closest("[data-product-option-group]");
    if (!group) return false;

    const buttons = group.querySelectorAll('[data-mrw="selectPdpOption"]');

    buttons.forEach((button) => {
      button.classList.remove("is-active");
      button.setAttribute("aria-checked", "false");
    });

    item.classList.add("is-active");
    item.setAttribute("aria-checked", "true");

    return true;
  }

  mrwSelectBundleOption(item) {
    if (!item.matches('[data-mrw="selectBundle"]')) return false;

    const group = item.closest("[data-product-bundle-option-group]");
    if (!group) return false;

    const buttons = group.querySelectorAll('[data-mrw="selectBundle"]');

    buttons.forEach((button) => {
      button.classList.remove("is-active");
      button.setAttribute("aria-checked", "false");
    });

    item.classList.add("is-active");
    item.setAttribute("aria-checked", "true");

    return true;
  }

  selectPdpOption(item) {
    const value = item.getAttribute("data-value");
    const option = item.getAttribute("data-option");

    const handledByMrw = this.mrwSelectPdpOption(item);

    if (!handledByMrw) {
      const selected = qs(".select-dropdown__dropdown__option.active");

      if (selected) {
        selected.classList.remove("active");
      }

      item.classList.add("active");
    }

    const open = functions.getOpenDropdown();
    functions.closePdpDropdown(open);

    const selectSpanEl = qs(
      `[data-action="togglePdpDropdown"][data-option="${option}"] span`
    );
    const selectButtonEl = qs(
      `[data-action="togglePdpDropdown"][data-option="${option}"]`
    );

    if (!selectButtonEl) return;

    // mrw - updates the hidden legacy state used by getSelectedVariant()
    selectSpanEl && (selectSpanEl.innerHTML = value);
    selectButtonEl.setAttribute("data-value", value);

    const errorEl = qs("#invalidOptionWarning");
    const selectedVariant = functions.getSelectedVariant();

    if (!selectedVariant || !selectedVariant.variantId) {
      const priceEl = qs('[data-content="price"]');
      const availabilityEl = qs('[data-content="productAvailability"]');
      const atcBtn = qs('[data-action="atc"]');

      if (priceEl) priceEl.innerHTML = "Not Available";
      if (availabilityEl) availabilityEl.innerHTML = "Not Available";
      if (atcBtn) atcBtn.setAttribute("disabled", "");

      return;
    }

    const atcBtn = qs('[data-action="atc"]');
    if (atcBtn) {
      atcBtn.removeAttribute("disabled");
      atcBtn.setAttribute("data-variantId", selectedVariant.variantId);
    }

    if (errorEl) {
      errorEl.classList.add("visually-hidden");
    }

    const priceEl = qs('[data-content="price"]');
    const availabilityEl = qs('[data-content="productAvailability"]');

    if (priceEl) priceEl.innerHTML = selectedVariant.price;
    if (availabilityEl) {
      availabilityEl.innerHTML = values.keys[selectedVariant.inventory];
    }
  }

  selectBundleColorOption(item) {
    const value = item.getAttribute("data-value");
    const option = item.getAttribute("data-option");
    const optionHandle = item.getAttribute("data-optionhandle");
    const baseId = item.getAttribute("data-baseid");

    const selected = qsa(
      `.select-dropdown__dropdown__option.active[data-optionhandle="${optionHandle}"][data-baseid="${baseId}"]`
    );

    if (selected.length) {
      for (let i = 0; i < selected.length; i++) {
        selected[i].classList.remove("active");
      }
    }

    item.classList.add("active");

    const open = functions.getOpenDropdown();
    if (open) {
      functions.closePdpDropdown(open);
    }

    const optionLabel = qs(
      `[data-action="togglePdpDropdown"][data-option="${option}"] span`
    );
    const optionButton = qs(
      `[data-action="togglePdpDropdown"][data-option="${option}"]`
    );

    if (optionLabel) optionLabel.innerHTML = value;
    if (optionButton) optionButton.setAttribute("data-value", value);

    let availableOptions = [];
    const currentOptionValues = qsa(
      `[data-action="selectBundleColorOption"][data-option="${option}"]`
    );

    for (let x = 0; x < currentOptionValues.length; x++) {
      availableOptions.push(currentOptionValues[x].getAttribute("data-value"));
    }

    let pillowCases =
      availableOptions.length === 2 &&
      availableOptions.includes("King") &&
      availableOptions.includes("Standard");
    let disableAddon = value === "No Thanks";

    const allOptions = qsa(
      `[data-action="togglePdpDropdown"][data-optionhandle="Size"]`
    );

    if (
      allOptions.length &&
      !pillowCases &&
      !disableAddon &&
      optionHandle === "Size"
    ) {
      for (let i = 0; i < allOptions.length; i++) {
        const optionElement = allOptions[i];
        const option = optionElement.getAttribute("data-option");
        const optionValue = optionElement.getAttribute("data-value");
        const optionValues = qsa(
          `[data-action="selectBundleColorOption"][data-option="${option}"]`
        );

        availableOptions = [];
        for (let x = 0; x < optionValues.length; x++) {
          availableOptions.push(optionValues[x].getAttribute("data-value"));
        }

        let pillowCases = false;
        if (
          availableOptions.length === 2 &&
          availableOptions.includes("King") &&
          availableOptions.includes("Standard")
        ) {
          pillowCases = true;
        }

        if (!pillowCases && optionValue !== value) {
          let newValue = value;

          switch (value) {
            case "Twin":
              break;
            case "Full":
              if (availableOptions.includes("Full/Queen")) {
                newValue = "Full/Queen";
              }
              break;
            case "Queen":
              if (availableOptions.includes("Full/Queen")) {
                newValue = "Full/Queen";
              }
              break;
            case "King":
              if (availableOptions.includes("King/Cal King")) {
                newValue = "King/Cal King";
              }
              break;
            case "Cal King":
              if (availableOptions.includes("King/Cal King")) {
                newValue = "King/Cal King";
              }
              break;
            case "Full/Queen":
              if (!availableOptions.includes("Full/Queen")) {
                newValue = "Full";
              }
              break;
            case "King/Cal King":
              if (!availableOptions.includes("King/Cal King")) {
                newValue = "King";
              }
              break;
            default:
              console.log(`not found`);
          }

          const addonOos = qs(`.select-dropdown__oos[data-addon-oos]`);

          try {
            const nextOption = qs(
              `[data-action="selectBundleColorOption"][data-option="${option}"][data-value="${newValue}"]`
            );
            const nextLabel = qs(
              `[data-action="togglePdpDropdown"][data-option="${option}"] span`
            );
            const nextButton = qs(
              `[data-action="togglePdpDropdown"][data-option="${option}"]`
            );
            const currentActive = qs(
              `.active[data-action="selectBundleColorOption"][data-option="${option}"]`
            );

            if (!nextOption) {
              throw new Error("Next option not found");
            }

            nextOption.classList.add("active");
            if (nextLabel) nextLabel.innerHTML = newValue;
            if (nextButton) nextButton.setAttribute("data-value", newValue);
            if (currentActive) currentActive.classList.remove("active");
            if (addonOos) addonOos.classList.add("hide");
          } catch (e) {
            console.log("error", e);

            if (addonOos) {
              addonOos.classList.remove("hide");
            }

            const fallbackLabel = qs(
              `[data-action="togglePdpDropdown"][data-option="${option}"] span`
            );
            const fallbackButton = qs(
              `[data-action="togglePdpDropdown"][data-option="${option}"]`
            );
            const currentActive = qs(
              `.active[data-action="selectBundleColorOption"][data-option="${option}"]`
            );

            if (fallbackLabel) fallbackLabel.innerHTML = "No Thanks";
            if (fallbackButton) {
              fallbackButton.setAttribute("data-value", "No Thanks");
            }
            if (currentActive) currentActive.classList.remove("active");
          }
        }
      }
    }

    const selectedColorVariant = functions.getSelectedBundleColorVariant();
    const priceWithDiscount =
      selectedColorVariant.price - selectedColorVariant.discountValue;

    const priceEl = qs('[data-content="price"]');
    const valueEl = qs('[data-content="value"]');
    const paymentsEl = qs('[data-content="payments"]');
    const atcBundle = qs('[data-action="atcBundle"]');

    if (priceEl) priceEl.innerHTML = priceWithDiscount.toString();
    if (valueEl) {
      valueEl.innerHTML = (
        priceWithDiscount + selectedColorVariant.discountValue
      ).toString();
    }
    if (paymentsEl) {
      paymentsEl.innerHTML = parseFloat(priceWithDiscount / 4)
        .toFixed(2)
        .toString();
    }

    if (atcBundle) {
      atcBundle.setAttribute(
        "data-selected-ids",
        selectedColorVariant.variants
      );
      atcBundle.setAttribute("data-bundle-sizes", selectedColorVariant.sizes);
      atcBundle.setAttribute("data-bundle-colors", selectedColorVariant.colors);
      atcBundle.setAttribute(
        "data-discount-code",
        selectedColorVariant.discountCode
      );
      atcBundle.setAttribute(
        "data-discount-value",
        selectedColorVariant.discountValue
      );
      atcBundle.setAttribute("data-addon-id", selectedColorVariant.addon);
    }

    const image = item.getAttribute("data-image");
    const imageDomElement = qs(".product__media__item.is-active img");
    if (image && imageDomElement) {
      imageDomElement.removeAttribute("srcset");
      imageDomElement.src = image;
    }
  }

  selectCollectionFilter(item) {
    const value = item.getAttribute("data-value");
    const selected = qs(".select-dropdown__dropdown__option.active");

    if (selected) {
      selected.classList.remove("active");
    }

    item.classList.add("active");

    const open = functions.getOpenDropdown();
    functions.closePdpDropdown(open);

    window.location.href = `#${value}`;
  }

  selectGridOption(item) {
    const productId = item.getAttribute("data-productId");
    const variantId = item.getAttribute("data-variantId");
    const error = qs(
      `[data-content="atcError"][data-productId="${productId}"]`
    );

    const atc = qs(`[data-productId="${productId}"][data-action="atc"]`);
    if (!atc) return;

    atc.setAttribute("data-variantId", variantId);

    const activeOption = qs(
      `.active[data-productId="${productId}"][data-action="selectGridOption"]`
    );
    if (activeOption) {
      activeOption.classList.remove("active");
    }

    item.classList.add("active");

    if (error) {
      error.classList.remove("active");
    }

    if (item.getAttribute("data-preorder") === "true") {
      atc.setAttribute("data-preorder", "true");
      atc.setAttribute(
        "data-preorder-date",
        item.getAttribute("data-preorder-date")
      );
    }
  }

  toggleExpandingMenu(item) {
    const status = item.getAttribute("data-status") || false;
    const group = item.getAttribute("data-group") || false;
    const handle = item.getAttribute("data-handle") || false;
    let openText = false;
    let closeText = false;

    for (let i = 0; i < elements.expandingMenus.length; i++) {
      const menu = elements.expandingMenus[i];
      if (group && menu.getAttribute("data-group") === group) {
        if (menu.getAttribute("data-status") === "open") {
          menu.setAttribute("data-status", "closed");
          closeText = qs(
            `[data-content="toggleExpandingMenu"][data-handle="${menu.getAttribute(
              "data-handle"
            )}"]`
          );
        }
      }
    }

    if (status === "open") {
      item.setAttribute("data-status", "closed");
      closeText = qs(
        `[data-content="toggleExpandingMenu"][data-handle="${handle}"]`
      );
    } else {
      item.setAttribute("data-status", "open");
      openText = qs(
        `[data-content="toggleExpandingMenu"][data-handle="${handle}"]`
      );
    }

    if (openText) {
      openText.style.maxHeight = openText.scrollHeight + "px";
      openText.setAttribute("data-status", "open");

      window.setTimeout(() => {
        openText.style.maxHeight = "unset";
      }, 201);
    }

    if (closeText) {
      closeText.style.maxHeight = closeText.scrollHeight + "px";
      window.setTimeout(() => {
        closeText.style.maxHeight = "0px";
        closeText.setAttribute("data-status", "closed");
      }, 1);
    }
  }

  toggleTooltip(item) {
    const status = item.getAttribute("data-status") || false;
    const group = item.getAttribute("data-group") || false;
    const handle = item.getAttribute("data-handle") || false;
    const type = item.getAttribute("data-type") || false;
    let openText = false;
    let closeText = false;

    for (let i = 0; i < elements.tooltips.length; i++) {
      const tooltip = elements.tooltips[i];
      if (group && tooltip.getAttribute("data-group") === group) {
        if (tooltip.getAttribute("data-status") === "open") {
          tooltip.setAttribute("data-status", "closed");
          closeText = qs(
            `[data-content="toggleTooltip"][data-handle="${tooltip.getAttribute(
              "data-handle"
            )}"]`
          );
        }
      }
    }

    if (status === "open") {
      item.setAttribute("data-status", "closed");
      closeText = qs(`[data-content="toggleTooltip"][data-handle="${handle}"]`);
    } else {
      item.setAttribute("data-status", "open");
      openText = qs(`[data-content="toggleTooltip"][data-handle="${handle}"]`);
    }

    if (openText) {
      openText.setAttribute("data-status", "open");
      if (type) openText.setAttribute("data-type", type);
    }

    if (closeText) {
      closeText.setAttribute("data-status", "closed");
    }
  }

  reducePdpQuantity(item) {
    const atcSelector = qs('[data-action="atc"]')
      ? '[data-action="atc"]'
      : '[data-action="atcBundle"]';

    const atc = qs(atcSelector);
    if (!atc) return;

    const newValue = (parseInt(atc.getAttribute("data-quantity"), 10) || 1) - 1;

    if (newValue > 0) {
      atc.setAttribute("data-quantity", newValue);
      const qty = qs('[data-content="pdpQuantity"]');
      if (qty) qty.innerHTML = newValue;
    }
  }

  increasePdpQuantity(item) {
    const atcSelector = qs('[data-action="atc"]')
      ? '[data-action="atc"]'
      : '[data-action="atcBundle"]';

    const atc = qs(atcSelector);
    if (!atc) return;

    const newValue = (parseInt(atc.getAttribute("data-quantity"), 10) || 1) + 1;

    atc.setAttribute("data-quantity", newValue);

    const qty = qs('[data-content="pdpQuantity"]');
    if (qty) qty.innerHTML = newValue;
  }

  toggleCart(item) {
    if (!elements.cart) return;

    if (elements.cart.classList.contains("active")) {
      cart.closeCart();
    } else {
      cart.openCart();
    }
  }

  toggleSearch(item) {
    if (!elements.searchBar) return;

    if (elements.searchBar.classList.contains("active")) {
      functions.closeSearchBar();
    } else {
      functions.openSearchBar();
    }
  }

  async setLineQuantity(item) {
    const line = item.getAttribute("data-line");
    const quantity = parseInt(item.getAttribute("data-quantity"), 10);
    const response = await cart.setLineQuantity(line, quantity);
    await cart.updateCart(response);
  }

  async setBundleLineQuantity(item) {
    const handle = item.getAttribute("data-bundle-handle");
    const timestamp = item.getAttribute("data-bundle-timestamp");
    const quantity = parseInt(item.getAttribute("data-quantity"), 10);

    const cartInstance = await fetch("/cart.js", {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
    })
      .then((response) => {
        return response.json();
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
        return false;
      });

    if (!cartInstance || !cartInstance.items) return;

    let lineUpdate = false;

    for (let i = 0; i < cartInstance.items.length; i++) {
      const lineItem = cartInstance.items[i];

      if (
        lineItem.properties &&
        lineItem.properties["_bundle_handle"] === handle &&
        lineItem.properties["_timestamp"] === timestamp
      ) {
        lineUpdate = await cart.setLineQuantity(lineItem.key, quantity);
      }
    }

    if (lineUpdate) {
      await cart.updateCart(lineUpdate);
    }
  }

  scrollToHandle(item) {
    const handle = item.getAttribute("data-handle");
    const scrollElem = qs(`[data-scrollId="${handle}"]`);

    if (scrollElem) {
      scrollElem.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
  }

  async subscribeKlaviyo(item) {
    const handle = item.getAttribute("data-form");
    const emailInput = qs(`input[name=email][data-form="${handle}"]`);
    const listInput = qs(`input[name=list][data-form="${handle}"]`);

    if (!emailInput || !listInput) return;

    const form = {
      email: emailInput.value,
      listId: listInput.value,
    };

    const fname = qs(`input[name=fname][data-form="${handle}"]`);
    if (fname && fname.value) form.fname = fname.value;

    const lname = qs(`input[name=lname][data-form="${handle}"]`);
    if (lname && lname.value) form.lname = lname.value;

    const website = qs(`input[name=website][data-form="${handle}"]`);
    if (website && website.value) form.website = website.value;

    const address1 = qs(`input[name=address1][data-form="${handle}"]`);
    if (address1 && address1.value) form.address1 = address1.value;

    const address2 = qs(`input[name=address2][data-form="${handle}"]`);
    if (address2 && address2.value) form.address2 = address2.value;

    const city = qs(`input[name=city][data-form="${handle}"]`);
    if (city && city.value) form.city = city.value;

    const state = qs(`input[name=state][data-form="${handle}"]`);
    if (state && state.value) form.state = state.value;

    const zip = qs(`input[name=zip][data-form="${handle}"]`);
    if (zip && zip.value) form.zip = zip.value;

    const response = await functions.subscribeKlaviyo(form);
    const responseDisplay = qs(
      `[data-content="response"][data-form="${handle}"]`
    );

    if (!responseDisplay) return;

    switch (response.status) {
      case "success":
        responseDisplay.innerHTML = "Check your email for confirmation";
        responseDisplay.classList.add("reveal");

        setTimeout(() => {
          this.closeKlaviyo(item);
        }, 2000);
        break;
      case "alreadySubscribed":
        responseDisplay.innerHTML = "Looks like you’re already subscribed.";
        responseDisplay.classList.add("reveal");
        break;
      case "errorOnSubscribe":
        responseDisplay.innerHTML = "Enter a valid email";
        responseDisplay.classList.add("reveal");
        break;
    }
  }

  async subscribeKlaviyoOos(item) {
    const handle = item.getAttribute("data-form");
    const emailInput = qs(`input[name=email][data-form="${handle}"]`);
    const listInput = qs(`input[name=list][data-form="${handle}"]`);

    if (!emailInput || !listInput) return;

    const form = {
      email: emailInput.value,
      listId: listInput.value,
      variantId: item.getAttribute("data-variant"),
    };

    const response = await functions.subscribeKlaviyoOos(form);
    const responseDisplay = qs(
      `[data-content="response"][data-form="${handle}"]`
    );

    if (!responseDisplay) return;

    switch (response.status) {
      case "success":
        responseDisplay.innerHTML = "Subscribed!";
        responseDisplay.classList.add("reveal");
        break;
      case "errorOnSubscribe":
        responseDisplay.innerHTML = "Subscribed!";
        responseDisplay.classList.add("reveal");
        break;
      case "errorOnOosSubscribe":
        responseDisplay.innerHTML = "Enter a valid email";
        responseDisplay.classList.add("reveal");
        break;
    }
  }

  closeKlaviyo(item) {
    const form = qs(`.reveal[data-form="${item.getAttribute("data-form")}"]`);
    if (form) {
      // form.classList.remove("reveal");
      // form.classList.add("disabled");
      cart.addKlaviyoCookie();
    }
  }

  async giftNoteAction(item) {
    const modal = qs(".gift-note-modal");
    const noteFieldEl = qs("textarea#GiftNote");

    if (!modal || !noteFieldEl) return;

    const noteField = noteFieldEl.value;
    let status = modal.getAttribute("data-status");

    if (status === "closed") {
      modal.setAttribute("data-status", "open");
      item.innerHTML = "Save";
    } else {
      item.innerHTML = noteField.length ? "Edit" : "Add";
      await cart.saveGiftNote(noteField);
      modal.setAttribute("data-status", "closed");
    }
  }
}

let actions = new Actions();

const clearActionEvents = (actions) => {
  for (let i = 0; i < actions.listeners.length; i++) {
    const iteration = actions.listeners[i];
    iteration.item.removeEventListener("click", iteration.listener, false);
  }
  return [];
};

const registerActionEvents = (actions) => {
  actions.listeners = clearActionEvents(actions);

  for (let i = 0; i < elements.actions.length; i++) {
    const item = elements.actions[i];
    const action = item.getAttribute("data-action");

    if (action === "toggleExpandingMenu") {
      const status = item.getAttribute("data-status") || false;
      const handle = item.getAttribute("data-handle") || false;

      if (status === "open") {
        const openText = qs(
          `[data-content="toggleExpandingMenu"][data-handle="${handle}"]`
        );
        if (openText) {
          openText.style.maxHeight = openText.scrollHeight + "px";
        }
      }
    }

    const listener = (event) => {
      event.preventDefault();

      if (action && typeof actions[action] === "function") {
        try {
          actions[action](item);
        } catch (error) {
          console.warn(`Action failed: ${action}`, error, item);
        }
      }
    };

    item.addEventListener("click", listener, false);
    actions.listeners.push({
      listener,
      handle: `${action}`,
      item,
    });
  }

  for (let i = 0; i < elements.preloadTriggers.length; i++) {
    const item = elements.preloadTriggers[i];
    const handle = item.getAttribute("data-handle");
    const source = item.getAttribute("data-preloadSource");
    const sizeElement = qs(`[data-preloadSize="${source}"]`);
    const preloadSrc = item.getAttribute("data-preload");

    if (!handle || !source || !sizeElement || !preloadSrc) continue;

    const widthsAttr = sizeElement.getAttribute("data-widths");
    if (!widthsAttr) continue;

    const size = sizeElement.clientWidth * 2;
    const widths = widthsAttr.replace("[", "").replace("]", "").split(",");

    let newSize = 300;
    for (let x = 0; x < widths.length; x++) {
      const width = parseInt(widths[x], 10);
      if (width > size) {
        newSize = width;
        break;
      }
    }

    const src300 = preloadSrc.replace("_777x", `_300x`);
    const src = preloadSrc.replace("_777x", `_${newSize}x`);

    item.addEventListener(
      "mouseover",
      function (event) {
        event.preventDefault();
        const imgSmall = new Image();
        const imgFull = new Image();
        imgSmall.src = src300;
        imgFull.src = src;

        values.preloads[handle] = {
          src300,
          src,
        };
      },
      false
    );
  }

  return actions;
};

/********************
 * Rendering
 ********************/

class Rendering {
  constructor() {
    this.init(this);
  }

  init(that) {
    window.addEventListener("orientationchange", () => {
      that.setAppHeights();
    });

    this.setAppHeights();

    window.addEventListener("resize", () => {
      that.setAppHeights();
    });
  }

  setAppHeights() {
    if (!elements.doc) return;

    elements.doc.style.setProperty(
      "--dynamic-app-height",
      `${window.innerHeight / 10}rem`
    );

    elements.doc.style.setProperty(
      "--app-height",
      `${window.innerHeight / 10}rem`
    );
  }
}

let rendering = new Rendering();

actions = registerActionEvents(actions);

if (qsa('[data-action="selectBundleColorOption"]').length) {
  const item = qsa('[data-action="selectBundleColorOption"]')[0];
  actions.selectBundleColorOption(item);
}

/********************
 * Sliders
 ********************/

class Sliders {
  constructor() {
    return this.init();
  }

  init() {
    const sliders = [];

    if (typeof Splide === "undefined") {
      console.warn("Splide is not available.");
      return sliders;
    }

    for (let i = 0; i < elements.sliders.length; i++) {
      const el = elements.sliders[i];
      const handle = el.getAttribute("data-slider");
      const type = el.getAttribute("data-slider-type");
      const selector = `[data-slider="${handle}"]`;

      if (!handle || !type) continue;

      if (typeof this[type] !== "function") {
        console.warn(`Unknown slider type: ${type}`, el);
        continue;
      }

      try {
        const instance = this[type](handle, selector);
        if (instance) sliders.push(instance);
      } catch (error) {
        console.warn(
          `Failed to init slider "${handle}" of type "${type}"`,
          error
        );
      }
    }

    return sliders;
  }

  customNav(slider) {
    if (!slider || !slider.root) return;

    const nextListener = (event) => {
      event.preventDefault();
      slider.go(">");
    };

    const prevListener = (event) => {
      event.preventDefault();
      slider.go("<");
    };

    const id = slider.root.getAttribute("data-slider");
    if (!id) return;

    const nextButton = qs(`.splide__arrow--next[data-slider="${id}"]`);
    const prevButton = qs(`.splide__arrow--prev[data-slider="${id}"]`);

    slider.on("mounted", () => {
      on(nextButton, "click", nextListener, false);
      on(prevButton, "click", prevListener, false);
    });

    slider.on("destroy", () => {
      off(nextButton, "click", nextListener, false);
      off(prevButton, "click", prevListener, false);
    });
  }

  horizontalSettings(slider, offset = 0) {
    if (!slider || !slider.root) return;

    const id = slider.root.getAttribute("data-slider");
    if (!id) return;

    slider.on("move", (newIndex) => {
      try {
        slider.Components.Slides.getAt(
          newIndex + 1 + offset
        )?.slide?.classList.add("show");
        const cta = qs(`.slider-cta[data-slider="${id}"]`);
        if (cta) cta.classList.remove("show");
      } catch (e) {
        const cta = qs(`.slider-cta[data-slider="${id}"]`);
        if (cta) cta.classList.add("show");
      }

      try {
        slider.Components.Slides.getAt(
          newIndex + 2 + offset
        )?.slide?.classList.remove("show");
        slider.Components.Slides.getAt(
          newIndex + 3 + offset
        )?.slide?.classList.remove("show");
      } catch (e) {}
    });
  }

  pdpHeader(handle, selector) {
    const root = qs(selector);
    if (!root) return null;

    const slider = new Splide(selector, {
      type: "loop",
      rewind: true,
      perMove: 1,
      perPage: 1,
      pagination: false,
      keyboard: "focused",
      speed: 600,
      easing: "cubic-bezier(0.32, 0.24, 0.15, 1)",
      dragMinThreshold: {
        mouse: 15,
        touch: 3,
      },
      flickMaxPages: 1,
      flickPower: 180,
      breakpoints: {
        1024: {
          flickPower: 400,
        },
      },
    });

    slider.on("moved", (e) => {
      const counter = qs(`[data-slider-count="${handle}"]`);
      if (counter) counter.innerText = e + 1;
    });

    slider.mount();

    return {
      slider,
      handle,
      type: "pdpHeader",
    };
  }

  collectionSlider(handle, selector) {
    const root = qs(selector);
    if (!root) return null;

    const slider = new Splide(selector, {
      type: "slider",
      rewind: false,
      speed: 600,
      drag: true,
      perView: 1,
      perPage: 1,
      perMove: 1,
      autoWidth: true,
      arrows: false,
      pagination: false,
      waitForTransition: true,
      keyboard: "focused",
      easing: "cubic-bezier(0.32, 0.24, 0.15, 1)",
      dragMinThreshold: {
        mouse: 24,
        touch: 10,
      },
      flickMaxPages: 1,
      flickPower: 100,
      breakpoints: {
        1024: {
          flickPower: 200,
        },
      },
    });

    const offset = window.innerWidth < 1024 ? 0 : 1;
    this.customNav(slider);
    this.horizontalSettings(slider, offset);

    slider.mount();

    return {
      slider,
      handle,
      type: "collectionSlider",
    };
  }

  mobileOnlySlider(handle, selector) {
    const root = qs(selector);
    if (!root) return null;

    const slider = new Splide(selector, {
      mediaQuery: "min",
      speed: 600,
      type: "slider",
      rewind: false,
      drag: true,
      perView: 1,
      perPage: 1,
      perMove: 1,
      autoWidth: true,
      arrows: false,
      pagination: false,
      waitForTransition: true,
      keyboard: "focused",
      slideFocus: true,
      easing: "cubic-bezier(0.32, 0.24, 0.15, 1)",
      dragMinThreshold: {
        mouse: 24,
        touch: 5,
      },
      flickPower: 200,
      breakpoints: {
        1024: {
          destroy: true,
        },
      },
    });

    this.customNav(slider);
    this.horizontalSettings(slider);

    slider.mount();

    return {
      slider,
      handle,
      type: "mobileOnlySlider",
    };
  }

  productCarousel(handle, selector) {
    const root = qs(selector);
    if (!root) return null;

    const slider = new Splide(selector, {
      type: "slider",
      speed: 600,
      rewind: false,
      drag: true,
      perView: 1,
      perPage: 1,
      perMove: 1,
      autoWidth: true,
      arrows: false,
      pagination: false,
      keyboard: "focused",
      slideFocus: true,
      easing: "cubic-bezier(0.32, 0.24, 0.15, 1)",
      noDrag: ".grid-item__hover__selection",
      dragMinThreshold: {
        mouse: 24,
        touch: 5,
      },
      flickMaxPages: 1,
      flickPower: 100,
      breakpoints: {
        1024: {
          flickPower: 200,
        },
      },
    });

    this.customNav(slider);
    this.horizontalSettings(slider);

    slider.mount();

    return {
      slider,
      handle,
      type: "productCarousel",
    };
  }

  lookbook(handle, selector) {
    const root = qs(selector);
    if (!root) return null;

    const autoplay = root.getAttribute("data-autoplay") === "true";

    const slider = new Splide(selector, {
      type: "fade",
      drag: true,
      speed: 600,
      perView: 1,
      perMove: 1,
      pagination: false,
      autoplay,
      interval: 5000,
      pauseOnFocus: false,
      pauseOnHover: false,
      rewind: true,
      easing: "cubic-bezier(0.32, 0.24, 0.15, 1)",
      arrows: false,
    });

    this.customNav(slider);

    slider.mount();

    return {
      slider,
      handle,
      type: "lookbook",
    };
  }
}

let sliders = new Sliders();

/********************
 * Scroll Events
 ********************/

document.addEventListener("DOMContentLoaded", function () {
  const windowHeight = window.innerHeight;
  const scrollCta = qs(".index-cta-slide");
  const disabledKey = window.localStorage.getItem("disable_klaviyo");

  window.addEventListener("scroll", function () {
    const scrollTop = document.documentElement.scrollTop;

    if (
      scrollCta &&
      !scrollCta.classList.contains("reveal") &&
      !scrollCta.classList.contains("disabled") &&
      disabledKey !== "true"
    ) {
      if (scrollTop > windowHeight / 4) {
        scrollCta.classList.add("reveal");
      }
    }
  });
});

/********************
 * Shopify API
 ********************/

class Cart {
  constructor() {
    return this.init();
  }

  init() {}

  async saveGiftNote(noteField) {
    let response;
    response = await fetch(`/cart/update.js`, {
      method: "POST",
      body: JSON.stringify({
        note: noteField,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
    });

    await response;
    const update = await this.updateCart();
    await update;
  }

  addKlaviyoCookie() {
    window.localStorage.setItem("disable_klaviyo", "true");
  }

  async cartErrorHandle(err, options) {
    console.log("err", err);
  }

  getCartValue(cartHtml) {}

  async updateCart(actionResponse = null) {
    // Shopify's Section Rendering API (?section_id=) against the built-in
    // /cart route — no custom page/template. mrw-cart-drawer is rendered
    // globally in theme.liquid, so it's part of /cart's render too.
    const data = await fetch("/cart?section_id=mrw-cart-drawer")
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        return parser.parseFromString(html, "text/html");
      })
      .catch(function (err) {
        console.warn("Something went wrong.", err);
        return false;
      });

    if (data) {
      const cartAjax = document.getElementById("mrw-cart-drawer-content");
      const body = data.getElementById("mrw-cart-drawer-content");

      if (cartAjax && body) {
        cartAjax.innerHTML = body.innerHTML;
      }

      functions.resetListeners();
      this.openCart();
      // Bridges to CartDrawer.js (the new mrw-cart-drawer), since this
      // legacy openCart()/closeCart() only toggle classes on the removed
      // .cart element and now no-op.
      document.dispatchEvent(new CustomEvent("mrw:cart-drawer:open"));

      const countAnchor = document.getElementById("countAnchor");
      const count = countAnchor
        ? parseInt(countAnchor.getAttribute("data-count"), 10) || 0
        : 0;

      const counts = qsa("[data-cart-count]");

      for (let i = 0; i < counts.length; i++) {
        counts[i].innerHTML = count;
      }

      // Emptied: the drawer stays open so its empty state
      // (mrw-cart-empty.liquid) can fade in. The remove button that had
      // focus was just replaced, so move focus there, which also has
      // screen readers announce "Your cart is empty".
      if (count < 1) {
        qs("[data-cart-empty]")?.focus();
      }
    }

    if (actionResponse && actionResponse.error) {
      const error = actionResponse.error;

      if (error.type === "setLineQuantity") {
        const currentLineQuantityEl = qs(
          `.cart__item__quantity__text[data-line^="${error.line}"]`
        );

        const currentLineQuantity = currentLineQuantityEl
          ? parseInt(currentLineQuantityEl.innerHTML, 10)
          : 0;

        if (error.quantity > currentLineQuantity) {
          const errorElem = qs(
            `.cart__item__quantity__error[data-line^="${error.line}"]`
          );
          if (errorElem) {
            errorElem.classList.add("active");
          }
        } else {
          await this.setLineQuantity(error.line, 0);
        }
      }
    }
  }

  async addToCart(id, quantity, preorder = false, preorderDate = false) {
    let body = JSON.stringify({
      id: parseInt(id, 10),
      quantity: parseInt(quantity, 10),
    });

    if (preorder) {
      body = JSON.stringify({
        id: parseInt(id, 10),
        quantity: parseInt(quantity, 10),
        properties: {
          "Ships On": preorderDate,
        },
      });
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body,
    })
      .then((response) => {
        return response.json();
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
        return false;
      });

    return await response;
  }

  async addBundleToCart(items, discount = false) {
    const timestamp = new Date();

    for (let i in items) {
      items[i].properties["_timestamp"] = timestamp.toString();
      if (discount) {
        items[i].properties["_discount_value"] = discount.value;
        items[i].properties["_discount_code"] = discount.code;
      }
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify({
        items,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
        return false;
      });

    return await response;
  }

  async setLineQuantity(line, quantity) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify({
        id: line,
        quantity: parseInt(quantity, 10),
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((err) => {
        console.log("error thrown");
        console.log(err);
        return false;
      });

    if (!response) {
      return {
        error: {
          type: "setLineQuantity",
          quantity: parseInt(quantity, 10),
          line: parseInt(line, 10),
        },
        response: false,
      };
    }

    if (response.status === 422) {
      return {
        error: {
          type: "setLineQuantity",
          quantity: parseInt(quantity, 10),
          line: parseInt(line, 10),
        },
        response: false,
      };
    }

    return {
      error: false,
      response: response,
    };
  }

  openCart() {
    if (elements.cart) {
      elements.cart.classList.add("active", "activated");
    }

    const overlay = qs(".cart__overlay");
    if (overlay) {
      overlay.classList.add("active");
    }

    if (elements.body) {
      elements.body.classList.add("no-scroll", "cart-open");
    }
  }

  closeCart() {
    if (elements.cart) {
      elements.cart.classList.remove("active");
    }

    const overlay = qs(".cart__overlay");
    if (overlay) {
      overlay.classList.remove("active");
    }

    if (elements.body) {
      elements.body.classList.remove("no-scroll", "cart-open");
    }
  }
}

const cart = new Cart();

// disorganized code starts here :)

function showAlert(event) {
  const slider = event.target.querySelector("[data-slider]");
  if (slider) {
    functions.resetListeners();
  }
}

document.addEventListener("shopify:section:load", showAlert);

function getSearchParams(k) {
  var p = {};
  location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
}

function addToKlaviyoListConfig(values) {
  return {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Revision: "2024-05-15",
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          custom_source: "online_store",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: values.email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: values.listId,
            },
          },
        },
      },
    }),
  };
}

function addToWaitlistConfig(values) {
  return {
    method: "POST",
    headers: {
      accept: "application/json",
      Revision: "2024-05-15",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: values.email,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${values.variantId}`,
            },
          },
        },
      },
    }),
  };
}
